import * as S from './styled';

function AccountStatBoxGraph ({ children }) {
  return <S.Container>
    {children}
  </S.Container>;
}

export default AccountStatBoxGraph;
